import { __decorate } from "tslib";
import { attr, customElement, FASTElement, html, when } from '@microsoft/fast-element';
import { SVG_ADOBE, SVG_SMARTPHONE, SVG_VIEW_SWITCH_EVERYONE, SVG_WHITEBOARD_ACTIVE, SVG_MUSIC, SVG_SCREEN_MIRRORING_LAPTOP, SVG_CONTINUE_20_PX, SVG_SKETCH, SVG_PICTURE_ACTIVE, SVG_CODE, SVG_CALENDAR_ACTIVE, SVG_PERSON_ACTIVE, SVG_FONT, SVG_ZIP, SVG_LOUD_SPEAKER, SVG_LINK_INACTIVE, SVG_NOTE, SVG_CHAT_ACTIVE, SVG_EDUCATION_ACTIVE, SVG_PHONE_UP_ACTIVE, SVG_WEBCAM_ON_ACTIVE, SVG_ROOM_PHYSICAL, SVG_HIGHLIGHTER, SVG_ROOM_VIEW, SVG_REMOTE_SUPPORT, SVG_HELPDESK, SVG_CAMERA_SHARE, SVG_GOTO, SVG_VECTOR, } from '@getgo/chameleon-icons';
import { ChameleonElementMixin } from '../../common/ChameleonElement';
import styles from './IconBadge.styles.scss';
const template = html `${when((x) => x.type, () => html `<chameleon-svg>${(x) => html `${x.getIcon()}`}</chameleon-svg>`)}`;
export const iconBadgeDefinition = { name: 'chameleon-icon-badge', template, styles };
let IconBadgeComponent = class IconBadgeComponent extends ChameleonElementMixin(FASTElement) {
    constructor() {
        super(...arguments);
        this.size = 'medium';
    }
    getIcon() {
        switch (this.getAttribute('type')) {
            case 'assist':
                return SVG_SCREEN_MIRRORING_LAPTOP;
            case 'assistmobile':
                return SVG_SMARTPHONE;
            case 'webinar':
                return SVG_LOUD_SPEAKER;
            case 'document':
                return SVG_NOTE;
            case 'pdf':
                return SVG_ADOBE;
            case 'partner':
                return SVG_GOTO;
            case 'spreadsheet':
                return SVG_VIEW_SWITCH_EVERYONE;
            case 'presentation':
                return SVG_WHITEBOARD_ACTIVE;
            case 'audio':
                return SVG_MUSIC;
            case 'video':
                return SVG_CONTINUE_20_PX;
            case 'sketch':
                return SVG_SKETCH;
            case 'image':
                return SVG_PICTURE_ACTIVE;
            case 'code':
                return SVG_CODE;
            case 'calendar':
                return SVG_CALENDAR_ACTIVE;
            case 'contact':
                return SVG_PERSON_ACTIVE;
            case 'font':
                return SVG_FONT;
            case 'zip':
                return SVG_ZIP;
            case 'vector':
                return SVG_VECTOR;
            case 'link':
                return SVG_LINK_INACTIVE;
            case 'messaging':
                return SVG_CHAT_ACTIVE;
            case 'call':
                return SVG_PHONE_UP_ACTIVE;
            case 'meeting':
                return SVG_WEBCAM_ON_ACTIVE;
            case 'training':
                return SVG_EDUCATION_ACTIVE;
            case 'room':
                return SVG_ROOM_PHYSICAL;
            case 'highlighter':
                return SVG_HIGHLIGHTER;
            case 'custom':
                return SVG_ROOM_VIEW;
            case 'gotoresolveremotesupport':
            case 'gotoresolvemobile':
                return SVG_REMOTE_SUPPORT;
            case 'gotoresolvehelpdesk':
                return SVG_HELPDESK;
            case 'gotoresolvecamerashare':
                return SVG_CAMERA_SHARE;
            case 'gotoresolve':
                return SVG_GOTO;
        }
        return '';
    }
};
__decorate([
    attr
], IconBadgeComponent.prototype, "type", void 0);
__decorate([
    attr
], IconBadgeComponent.prototype, "size", void 0);
__decorate([
    attr({ mode: 'boolean' })
], IconBadgeComponent.prototype, "disabled", void 0);
IconBadgeComponent = __decorate([
    customElement(iconBadgeDefinition)
], IconBadgeComponent);
export { IconBadgeComponent };
